// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refund-page {
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .refund-page h1 {
    font-size: 2rem;
    color: #333;
    text-align: center;
  }
  
  .refund-page h2 {
    font-size: 1.5rem;
    color: #555;
    margin-top: 20px;
  }
  
  .refund-page p {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
  }
  
  .refund-page ul {
    list-style-type: disc;
    margin-left: 20px;
    color: #666;
  }
  
  .refund-page section {
    margin-bottom: 30px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Refund.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".refund-page {\n    max-width: 800px;\n    margin: 20px auto;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  .refund-page h1 {\n    font-size: 2rem;\n    color: #333;\n    text-align: center;\n  }\n  \n  .refund-page h2 {\n    font-size: 1.5rem;\n    color: #555;\n    margin-top: 20px;\n  }\n  \n  .refund-page p {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #666;\n  }\n  \n  .refund-page ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    color: #666;\n  }\n  \n  .refund-page section {\n    margin-bottom: 30px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
